// extracted by mini-css-extract-plugin
export default {"cta":"CTA_cta__pWxqm","revert":"CTA_revert__RglLC"};